<template>
  <div class="d-flex align-center justify-center fill-height">
    <v-row
      class="fill-height"
      align-content="center"
      justify="center"
    >
      <v-col
        class="text-center"
        cols="12"
      >
        {{ message }}
      </v-col>
      <v-col cols="6">
        <v-progress-linear
          color="primary"
          indeterminate
          rounded
          height="6"
        ></v-progress-linear>
      </v-col>
    </v-row>
  </div>
</template>

<script>
/* eslint-disable */
import { Component, Vue } from 'vue-property-decorator'

@Component({
  props: {
    message: {
      type: String,
      default: 'Cargando... Por favor espere.'
    }
  }
})
export default class Loading extends Vue {}
</script>
